import React from 'react'

import { IOrganization } from './dashboard.interface'

type DashboardContextProps = {
  activeIndex: string
  setActiveIndex: (index: string) => void
  organizationList: Array<IOrganization>
  setOrganizationList: (organizations: Array<IOrganization>) => void
  selectedOrganization: IOrganization
  setSelectedOrganization: (organization: IOrganization) => void
}

const DashboardContext = React.createContext<DashboardContextProps>({
  organizationList: [],
  activeIndex: '',
  setActiveIndex: () => {},
  setOrganizationList: () => {},
  selectedOrganization: {
    id: '',
    name: '',
    roles: [''],
    orgNr: '',
  },
  setSelectedOrganization: () => {},
})

export const DashboardProvider = DashboardContext.Provider
export const DashboardConsumer = DashboardContext.Consumer
export default DashboardContext
